module.exports = __webpack_public_path__ + "img/logo.eeccd1e1.svg";